import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  orderMonitoring: {
    id: 'orderMonitoring',
    contentComponent: 'orderMonitoring',
    title: 'Orders',
    params: { type: 'orderMonitoring' },
  },
  tradeMonitoring: {
    id: 'tradeMonitoring',
    contentComponent: 'tradeMonitoring',
    title: 'Trades',
    params: { type: 'tradeMonitoring' },
  },
  executionReportMonitoring: {
    id: 'executionReportMonitoring',
    contentComponent: 'executionReportMonitoring',
    title: 'Execution Reports',
    params: { type: 'executionReportMonitoring' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        visible: true,
        data: { views: ['orderMonitoring'], activeView: 'orderMonitoring', id: 'orderMonitoring' },
        size: 533,
      },
      {
        type: LEAF,
        visible: true,
        data: { views: ['tradeMonitoring'], activeView: 'tradeMonitoring', id: 'tradeMonitoring' },
        size: 533,
      },
      {
        type: LEAF,
        visible: true,
        data: {
          views: ['executionReportMonitoring'],
          activeView: 'executionReportMonitoring',
          id: 'executionReportMonitoring',
        },
        size: 534,
      },
    ],
    size: 900,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.HORIZONTAL,
};

export const THREE_COLUMN_MONITORING_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
